/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('curriculum.filter', function (el) {
        new TableFilter(el).run();
    });
    var TableFilter = /** @class */ (function () {
        function TableFilter(el) {
            this._ASC = 'asc';
            this._DESC = 'desc';
            this.table = el.querySelector(el.dataset.tableSelector);
            this.searchInput = document.getElementById('searchInput');
            this.alphabetButtons = Array.from(document.querySelectorAll('.btn-alpabet'));
            this.categoryButtons = Array.from(document.querySelectorAll('.btn-category'));
            this.semesterButtons = Array.from(document.querySelectorAll('.btn-semester'));
            this.thElements = Array.from(this.table.querySelectorAll('th[data-sort]'));
            this.rowElements = Array.from(this.table.querySelectorAll('tbody tr.sort'));
            this.allRowElements = Array.from(this.table.querySelectorAll('tbody tr'));
            this.currentCategory = '';
            this.currentSemester = '';
            this.currentLetter = '';
            this.currentSearcnInput = '';
        }
        TableFilter.prototype.run = function () {
            this.setupSorting();
            this.setupSearching();
            this.setupAlphafilters();
            this.setupCategoryFilters();
            this.setupSemesterFilters();
        };
        TableFilter.prototype.setupSearching = function () {
            var _this = this;
            this.searchInput.addEventListener('input', function () {
                var input = _this.searchInput.value.trim().toLowerCase();
                clearTimeout(_this.timeout);
                if (input !== _this.currentSearcnInput) {
                    _this.timeout = setTimeout(function () {
                        _this.currentSearcnInput = input;
                        _this.applySearch();
                    }, 250);
                }
            });
        };
        TableFilter.prototype.setupSorting = function () {
            var _this = this;
            var sortingColumn = null;
            var ascending = true;
            var clickCount = 0; // Counter to track the number of clicks on the same header
            this.thElements.forEach(function (th) {
                th.addEventListener('click', function () {
                    var sortAttribute = th.getAttribute('data-sort');
                    if (!sortAttribute) {
                        return;
                    }
                    if (sortingColumn === sortAttribute) {
                        clickCount++;
                        if (clickCount === 3) {
                            th.classList.remove('desc');
                            clickCount = 0;
                            _this.applySearch();
                            return;
                        }
                        ascending = !ascending;
                    }
                    else {
                        sortingColumn = sortAttribute;
                        ascending = true;
                        clickCount = 1;
                    }
                    _this.thElements.forEach(function (otherTh) {
                        if (otherTh !== th) {
                            otherTh.classList.remove('asc', 'desc');
                        }
                    });
                    th.classList.toggle('asc', ascending);
                    th.classList.toggle('desc', !ascending);
                    var rows = _this.applySearch();
                    if (!rows) {
                        rows = _this.rowElements;
                    }
                    rows.sort(function (a, b) { return TableFilter.compareRows(a, b, sortingColumn, ascending); });
                    _this.updateTable(rows);
                });
            });
        };
        TableFilter.prototype.rowContainsValue = function (row, searchQuery) {
            return Array.from(row.querySelectorAll('td')).some(function (td) {
                var _a;
                var textContent = ((_a = td.textContent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
                return textContent.includes(searchQuery);
            });
        };
        TableFilter.compareRows = function (a, b, column, ascending) {
            var aValue = TableFilter.getDataValue(a, column);
            var bValue = TableFilter.getDataValue(b, column);
            return ascending ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
        };
        TableFilter.getDataValue = function (row, key) {
            var dataAttribute = row.querySelector("td[data-" + key + "]");
            return (dataAttribute === null || dataAttribute === void 0 ? void 0 : dataAttribute.textContent) || '';
        };
        TableFilter.prototype.updateTable = function (sortedRows) {
            var tbody = this.table.querySelector('tbody');
            if (!tbody)
                return;
            tbody.innerHTML = '';
            sortedRows.forEach(function (row) {
                tbody.appendChild(row);
            });
        };
        TableFilter.prototype.setupAlphafilters = function () {
            var _this = this;
            this.alphabetButtons.forEach(function (button) {
                util.delegate(button, 'click', 'button', function () {
                    var selectedLetter = button.dataset.letter;
                    _this.currentLetter = selectedLetter !== _this.currentLetter ? selectedLetter : '';
                    var currentAlphaButton = button.classList.contains('selected');
                    _this.resetButtons(_this.alphabetButtons);
                    button.classList.add('selected');
                    if (_this.currentLetter === '' || currentAlphaButton) {
                        button.classList.remove('selected');
                    }
                    _this.applySearch();
                });
            });
        };
        TableFilter.prototype.rowHasLetter = function (row, letter) {
            return row.dataset.letter === letter;
        };
        TableFilter.prototype.setupCategoryFilters = function () {
            var _this = this;
            this.categoryButtons.forEach(function (button) {
                util.delegate(button, 'click', 'button', function () {
                    _this.currentCategory = button.dataset.category;
                    var currentButton = button.classList.contains('selected');
                    if (currentButton) {
                        _this.currentCategory = '';
                    }
                    _this.resetButtons(_this.categoryButtons);
                    button.classList.add('selected');
                    if (_this.currentCategory === '' || currentButton) {
                        button.classList.remove('selected');
                    }
                    _this.applySearch();
                });
            });
        };
        TableFilter.prototype.rowHasCategory = function (row, category) {
            var categoriesString = row.dataset.categories;
            if (!categoriesString) {
                return false;
            }
            var categories = JSON.parse(categoriesString);
            var res = [];
            for (var i in categories) {
                res.push(categories[i]);
            }
            return res.includes(category);
        };
        TableFilter.prototype.resetButtons = function (buttons) {
            buttons.forEach(function (btn) {
                btn.classList.remove('selected');
            });
        };
        TableFilter.prototype.applySearch = function () {
            var _this = this;
            if (this.currentCategory === '' && this.currentLetter === '' && this.currentSearcnInput === '' && this.currentSemester === '') {
                this.updateTable(this.allRowElements);
                this.resetSorting();
                return this.rowElements;
            }
            var filteredRows = this.rowElements;
            if (this.currentCategory !== '') {
                filteredRows = filteredRows.filter(function (row) { return _this.rowHasCategory(row, _this.currentCategory); });
            }
            if (this.currentSemester !== '') {
                filteredRows = filteredRows.filter(function (row) { return _this.rowHasSemester(row, _this.currentSemester); });
            }
            if (this.currentLetter !== '') {
                filteredRows = filteredRows.filter(function (row) { return _this.rowHasLetter(row, _this.currentLetter); });
            }
            if (this.currentSearcnInput !== '') {
                filteredRows = filteredRows.filter(function (row) { return _this.rowContainsValue(row, _this.currentSearcnInput); });
            }
            this.updateTable(filteredRows);
            this.resetSorting();
            return filteredRows;
        };
        TableFilter.prototype.resetSorting = function () {
            var _this = this;
            this.thElements.forEach(function (th) {
                th.classList.remove(_this._ASC, _this._DESC);
            });
        };
        TableFilter.prototype.setupSemesterFilters = function () {
            var _this = this;
            this.semesterButtons.forEach(function (button) {
                util.delegate(button, 'click', 'button', function () {
                    _this.currentSemester = button.dataset.semester;
                    var currentButton = button.classList.contains('selected');
                    if (currentButton) {
                        _this.currentSemester = '';
                    }
                    _this.resetButtons(_this.semesterButtons);
                    button.classList.add('selected');
                    if (_this.currentSemester === '' || currentButton) {
                        button.classList.remove('selected');
                    }
                    _this.applySearch();
                });
            });
        };
        TableFilter.prototype.rowHasSemester = function (row, currentSemester) {
            var semesters = row.dataset.semesters;
            if (!semesters) {
                return false;
            }
            var categories = semesters.split(',').map(function (semester) { return semester.trim().toLowerCase(); });
            var res = [];
            for (var i in categories) {
                res.push(categories[i]);
            }
            return res.includes(currentSemester.toLowerCase());
        };
        return TableFilter;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
